import { X } from "lucide-react"

interface ChartErrorBannerProps {
  reason: string
  rawJson: string
  onDismiss: () => void
}

export function ChartErrorBanner({ reason, rawJson, onDismiss }: ChartErrorBannerProps) {
  return (
    <div
      className="my-2 rounded-md border border-brand-coral/30 bg-brand-coral-wash p-3"
      role="alert"
    >
      <div className="flex items-start justify-between gap-2">
        <p className="text-sm text-brand-coral-deep">
          <span aria-hidden="true">⚠ </span>
          This chart couldn&apos;t be rendered — {reason}. Raw data below.
        </p>
        <button
          onClick={onDismiss}
          className="shrink-0 rounded p-0.5 text-brand-coral-deep hover:bg-brand-coral/10"
          aria-label="Dismiss chart error"
        >
          <X size={14} />
        </button>
      </div>
      <pre className="mt-2 overflow-x-auto rounded bg-white/70 p-2 text-xs font-mono text-brand-ink-soft">
        {rawJson}
      </pre>
    </div>
  )
}
